export const Z_INDEX = {
  MAP: 10,
  FAB_PORTAL: 20,
  NAVBAR: 100,
  NAVIGATION_DRAWER: 102,
  NAVIGATION_DRAWER_OVERLAY: 101,
  SLIDE_OUT_PANEL: 102,
  SLIDE_OUT_PANELL_OVERLAY: 101,
  BOTTOM_TAB_BAR: 103,
  // TODO. Keep track in the redux store of the latest overlay z-index and make sure new overlays it rather than hardcoding z-index for modals
  OLD_MODAL: 10000,
  MODAL: 10001,
  SNACKBAR: 10002,
  APP_PROMOTION: 10003,
  BOTTOM_SHEET_BACKDROP: 1000,
  BOTTOM_SHEET: 1001,
} as const;

export const DEFAULT_NAVBAR_HEIGHT = 64;

/**
 * Visible height of the user info banner, which sits in flow above the fixed headers;
 * those headers offset their `top` by it so the banner is never covered.
 */
export const USER_INFO_BANNER_OFFSET_VAR = '--user-info-banner-offset';
export const USER_INFO_BANNER_OFFSET = `var(${USER_INFO_BANNER_OFFSET_VAR}, 0px)`;
